import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/", label: "首页" },
  { to: "/rankings", label: "30条大盘点" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

const categoryLinks = [
  { to: "/rankings?category=恋情绯闻", label: "恋情绯闻" },
  { to: "/rankings?category=剧组风波", label: "剧组风波" },
  { to: "/rankings?category=合约解约", label: "合约解约" },
  { to: "/rankings?category=舞台争议", label: "舞台争议" },
];

const otherLinks = [
  { to: "/rankings?category=商业代言", label: "商业代言" },
  { to: "/rankings?category=形象争议", label: "形象争议" },
  { to: "/rankings?category=综艺名场面", label: "综艺名场面" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-900 text-primary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950 font-heading font-black text-lg leading-none">
                瓜
              </span>
              <span className="font-heading font-black text-lg text-background-50">瓜网30</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200">
              把零散的娱乐爆料，整理成能看清脉络的事件盘点。一条一瓜，标注核心人物与冲突点，从起因到发酵一页看完。
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h3 className="font-heading text-sm font-bold text-background-50 mb-4">站内导航</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="主题分类导航">
            <h3 className="font-heading text-sm font-bold text-background-50 mb-4">主题分类</h3>
            <ul className="space-y-2.5">
              {categoryLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50 mb-4">更多分类</h3>
            <ul className="space-y-2.5">
              {otherLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-primary-200 hover:text-background-50 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-sm text-primary-200">
              投稿与纠错：
              <br />
              <span className="text-background-50">tips@guawang30.com</span>
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-300">
            © 2026 瓜网30 · 内容为网友投稿与公开讨论整理，人物均为化名，仅供娱乐参考
          </p>
          <p className="text-xs text-primary-300">
            我们不做事实裁定，只做信息整理与时间线还原
          </p>
        </div>
      </div>
    </footer>
  );
}